import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

import { ContentContainer, PrivateContainer, RightContainer } from './style';
import { Loader } from '../ui-component';
import { getValueFromLocalStorage } from '../utils/common';

type PrivateWrapperProps = {
  Content: () => JSX.Element | null;
  sidebarRequired?: boolean;
};

const PrivateWrapper = ({ Content, sidebarRequired = true }: PrivateWrapperProps) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userToken');
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');

    navigate('/login');
  };

  useEffect(() => {
    // Check auth based on your own tokens
    const token = getValueFromLocalStorage('userToken') || getValueFromLocalStorage('token');

    if (token) {
      setIsAuthenticated(true);
      // keep a simple flag in LS if you want to read it elsewhere
      localStorage.setItem('isAuthenticated', 'true');
    } else {
      handleLogout();
    }

    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <Loader showLoader={isLoading} />;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <PrivateContainer sidebarRequired={sidebarRequired}>
      {sidebarRequired ? (
        <>
          <Sidebar />
          <RightContainer>
            <Header />
            <ContentContainer>
              <Content />
            </ContentContainer>
          </RightContainer>
        </>
      ) : (
        <ContentContainer hasHeader={true}>
          <Content />
        </ContentContainer>
      )}
    </PrivateContainer>
  );
};

export default PrivateWrapper;
